import React from 'react'
import NoItemCreated from "assests/NoItemCreated.svg";
import CustomTypography from 'components/Fileds/CustomTypography';
import { Box, useTheme } from '@mui/material';
import "./style.css";
import { Warning } from '@mui/icons-material';

const NoItemsCreated = ({title, subtitle, isWarning=false, warningTxt, img, width, height, children}) => {
    const theme = useTheme();
  return (
    <Box className='d-flex align-items-center justify-content-center empty-card-contianer' sx={{flexDirection:'column'}}>
        <img
            src={img ? img :NoItemCreated}
            alt='empty'
            className='empty-image'
            style={{width: width ? width :"300px", height: height? height : "300px", marginBottom: '15px'}}
        />
        <Box className='d-flex align-items-center justify-content-center empty-card-text' sx={{flexDirection:'column'}}>
            <CustomTypography
                label={title}
                sx={{fontSize:'24px', fontWeight: 700, color:theme.palette.lightgrey.main, mb: 1}}
            />
            <CustomTypography
                label={subtitle}
                sx={{fontSize:'14px', fontWeight: 400, color:theme.palette.lightgrey.main, mb: 1, maxWidth:'300px'}}
            />

           {isWarning && 
                <Box className='d-flex align-items-center warning-container' sx={{backgroundColor:theme.palette.drawermenuitem.main}}>
                    <Warning sx={{color:'yellow'}}/>
                    <CustomTypography
                        label={warningTxt}
                        sx={{fontSize:'14px', fontWeight: 400, color:"white", mb: 0}}
                    />
                </Box>
            }
            {children}
        </Box>
    </Box>
  )
}

export default NoItemsCreated
